import { controls, currencyToNumber, grouped } from "../../controls";


const daybook = {
  label: "Loan Register",
  starting: true,
  url: "loan_register",
  pageLabel: "Loan Register",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", defaultValue: "assigned_branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),


    ...controls.displayText({ tab: "filter", label: "Society" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Society",  placeHolder: "Society Code", name: "society_code", fastpath: "societies" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "society_display" }),

    ...controls.magicDateLabel({ label: "Date", target: "as_on_date" }),
    ...controls.magicDate({ dateType: "ontype", default: "3 years ago", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),




  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Loan Register",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center",
        width: 30,
        width132: { size: 3 }
      },
      {
        Header: "GL Code",
        accessor: "gl_code",
        width: 100
      },
      {
        Header: "GL Name",
        accessor: "gl_display",
        rwidth: "*",
      },
      {
        Header: "Member ID",
        accessor: "member_ID",
        width: 100
      },
      {
        Header: "Name",
        accessor: "member_name",
        width: 100
      },
      {
        Header: "Acccount No",
        accessor: "account_no"
      },
      {
        Header: "Shares",
        accessor: "shares"
      },
      {
        Header: "Deposits",
        accessor: "deposits"
      },

      {
        Header: "Outstanding",
        columns: [
          {
            Header: "ST",
            accessor: "st_outstanding"
          },
          {
            Header: "MT",
            accessor: "mt_outstanding"
          },
          {
            Header: "LT",
            accessor: "lt_outstanding"
          },
        ]
      },
      {
        Header: "Overdue",
        columns: [
          {
            Header: "ST",
            accessor: "st_overdue"
          },
          {
            Header: "MT",
            accessor: "mt_overdue"
          },
          {
            Header: "LT",
            accessor: "lt_overdue"
          },
          {
            Header: "Interest",
            accessor: "interest_overdue"
          },
        ]
      },
      {
        Header: "Overdue Date",
        columns: [
          {
            Header: "ST",
            accessor: "st_overdue_date"
          },
          {
            Header: "MT",
            accessor: "mt_overdue_date"
          },
          {
            Header: "LT",
            accessor: "lt_overdue_date"
          }
        ]
      },
      {
        Header: "Penal",
        columns: [
          {
            Header: "ST",
            accessor: "st_penal"
          },
          {
            Header: "MT",
            accessor: "mt_penal"
          },
          {
            Header: "Surcharge",
            accessor: "lt_surcharge"
          },
        ]
      }
    ]
  }
};

export default daybook;